import { API_TYPE } from '@umu/umu-fetch';
const BASE = '/uapi/v1';
export const NavigationApi = {
    USE_NAVIGATION_LIST: {
        url: `${BASE}/enterprise/se-nav-list`, //获取 USE 用户导航配置
        type: API_TYPE.GET,
    },
    SET_USE_NAVIGATION_LIST: {
        url: `/uapi/v1/enterprise/se-nav-save`, // 设置 USE 用户导航配置
        type: API_TYPE.POSTFORMDATA,
    },
    APP_NAVIGATION_LIST: {
        url: `${BASE}/enterprise/nav-list`,//获取 APP导航配置
        type: API_TYPE.POST,
    },
    SET_APP_NAVIGATION_LIST: {  // 设置 APP导航配置
        url: `/uapi/v1/enterprise/nav-save`,
        type: API_TYPE.POSTFORMDATA,
    },
}
